import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Side Panel 상태 관리 스토어 (구 FilterStore)
 *
 * 사이드 패널의 고정/활성화 상태를 전역적으로 관리합니다.
 * persist 미들웨어를 통해 새로고침 시에도 상태가 유지됩니다.
 *
 * @property pinned - 패널 고정 여부 (데스크톱에서 항상 표시)
 * @property isPanelOpen - 패널 활성화 여부 (모바일/태블릿에서 토글)
 * @property setPinned - 패널 고정 상태 설정
 * @property setIsPanelOpen - 패널 활성화 상태 설정
 */
interface SidePanelStore {
  pinned: boolean; // default: false
  isPanelOpen: boolean; // default: false; (구 filterEnabled)
  setPinned: (pinned: boolean) => void;
  setIsPanelOpen: (isOpen: boolean) => void;
}

export const useSidePanelStore = create<SidePanelStore>()(
  persist(
    (set) => ({
      pinned: false,
      isPanelOpen: false,
      setPinned: (pinned) => set({ pinned }),
      setIsPanelOpen: (isPanelOpen) => set({ isPanelOpen }),
    }),
    {
      name: 'side-panel-storage', // storage key 변경
      partialize: (state) => ({
        pinned: state.pinned,
        isPanelOpen: state.isPanelOpen,
      }),
    },
  ),
);
